export enum LocaleLang {
  EN = 'EN',
  CN = 'CN',
}
export const DEFAULT_LOCALE_LANG = LocaleLang.CN;
